module.exports = __webpack_public_path__ + "static/img/location.b2595735.png";